// extracted by mini-css-extract-plugin
export default {"wrap":"StatusTooltip_wrap__dyHK2","tooltip":"StatusTooltip_tooltip__fOoai","caret":"StatusTooltip_caret__5BfzM"};